var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdminTable',{attrs:{"columns":_vm.columns,"title":`Коллекция settings`,"model-name":"settingsModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }